<p-treeTable [value]="partners" [autoLayout]="true">
    <ng-template pTemplate="header">
        <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Nazwa</th>
            <th scope="col">KRS</th>
            <th scope="col">NIP</th>
            <th scope="col">PESEL</th>
            <th *ngIf="!peselsOnly" scope="col">Rodzaj dokumentu</th>
            <th *ngIf="!peselsOnly" scope="col">Numer dokumentu</th>
            <th scope="col">Zaświadczenie z KRK</th>
            <th  scope="col" style="text-align: right"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td class="text-align-center red" colspan="10">
                Brak wspólników. Nie można złożyć wniosku. Skontaktuj się z KRS aby poprawić dane.
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-shareholder="rowData" let-node="node">
        <tr>
            <td>{{node.label}}</td>
            <td><i class="pi {{shareholder.personalData ? 'pi-user' : 'pi-building'}}" aria-hidden="true"></i></td>
            <td>{{shareholder.personalData ? shareholder.personalData.firstname + ' ' + shareholder.personalData.surname : shareholder.name}}</td>
            <td>{{shareholder.krs}}</td>
            <td>{{shareholder.nip}}</td>
            <td>{{shareholder.personalData?.pesel}}</td>
            <td *ngIf="!peselsOnly">{{shareholder.personalData?.identityType ? identityTypesMap.get(shareholder.personalData.identityType) : ''}}</td>
            <td *ngIf="!peselsOnly">{{shareholder.personalData?.identityValue}}</td>
            <td>
                <i *ngIf="shareholder.type?.startsWith('OF_P') && !shareholder.personalData.krkId" class="pi pi-exclamation-circle p-error" aria-hidden="true"></i>
                {{shareholder.personalData?.krkId ? krkMap.get(shareholder.personalData?.krkId)?.name : ''}}
            </td>
            <td>
                <p-button *ngIf="shareholder.type?.startsWith('OF_P')" pRipple type="button" icon="pi pi-pencil" (onClick)="onShareholderRowEdit(shareholder, node)" styleClass="p-button-warning"></p-button>
            </td>
        </tr>
    </ng-template>
</p-treeTable>

<p-dialog header="Edytuj {{shareholder.boardMember ? 'członka zarządu' : 'wspólnika'}}"
          [(visible)]="displayShareholderAdding"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-11 md:wp-6"
          (onHide)="onDialogClosed()">
    <form #addPartnerForm="ngForm">
        <ul class="list-none p-0 m-0">
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Imię/imiona</div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="firstNameMask" [placeholder]="firstNamePlaceholder"
                                 [(ngModel)]="shareholder.personalData!.firstname" [required]="true"
                                 minlength="2" #pname="ngModel" name="name" autocomplete="off"
                                 characterPattern="[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]"></p-inputMask>
                    <small *ngIf="pname.invalid && (pname.dirty || pname.touched)" class="p-error">
                        <div *ngIf="pname?.errors?.['required']">
                            Imię jest wymagane.
                        </div>
                        <div *ngIf="pname.errors?.['minlength']">
                            Imię musi mieć co najmniej 2 znaki.
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.firstname}}
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Nazwisko</div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="surnameMask" [placeholder]="surnamePlaceholder"
                                 [(ngModel)]="shareholder.personalData!.surname" [required]="true"
                                 minlength="2" #psurname="ngModel" name="surname" autocomplete="off"
                                 characterPattern="[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]"></p-inputMask>
                    <small *ngIf="psurname.invalid && (psurname.dirty || psurname.touched)" class="p-error">
                        <div *ngIf="psurname?.errors?.['required']">
                            Nazwisko jest wymagane.
                        </div>
                        <div *ngIf="psurname.errors?.['minlength']">
                            Nazwisko musi mieć co najmniej 2 znaki.
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.surname}}
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">NIP
                    <i class="pi pi-info-circle" pTooltip="Jeśli nie posiadasz NIP-u osoby fizycznej zaznacz odpowiedni checkbox." aria-hidden="true"></i>
                </div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask mask="9999999999" autocomplete="off"
                        [(ngModel)]="shareholder.nip" #pnip="ngModel"
                        [required]="true" [disabled]="shareholder.noNip!"
                        [autoClear]=false [minlength]="10" name="nip" nipValidator>
                    </p-inputMask>
                    <small *ngIf="pnip.invalid && (pnip.dirty ||pnip.touched)" class="p-error">
                        <div *ngIf="pnip?.errors?.['required']">
                            Numer NIP jest wymagany.
                        </div>
                        <div *ngIf="pnip.errors?.['nip']">
                            Niepoprawny numer NIP
                        </div>
                        <div *ngIf="pnip?.errors?.['minlength']">
                            Numer NIP musi składać się z 10 cyfr
                        </div>
                    </small>
                </div>
            </li>

            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Brak numeru NIP</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-checkbox [(ngModel)]="shareholder.noNip" [binary]="true" (onChange)="noNipChanged($event.checked)" name="noNip"></p-checkbox>
                </div>
            </li>

            <li *ngIf="!noPesel" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">PESEL</div>
                <div *ngIf="!alreadyFilled && !shareholder.personalData!.krkId" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="peselMask" [placeholder]="peselPlaceholder"
                                 [(ngModel)]="shareholder.personalData!.pesel"
                                 #ppesel="ngModel" [required]="true" [autoClear]=false [minlength]="11"
                                 autocomplete="off" peselValidator name="pesel"></p-inputMask>
                    <small *ngIf="ppesel.invalid && (ppesel.dirty && ppesel.touched)" class="p-error">
                        <div *ngIf="ppesel?.errors?.['required']">
                            PESEL jest wymagany
                        </div>
                        <div *ngIf="ppesel.errors?.['pesel']">
                            Niepoprawny numer PESEL
                        </div>
                        <div *ngIf="ppesel?.errors?.['minlength']">
                            Numer PESEL musi składać się z 11 cyfr
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled || shareholder.personalData!.krkId" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.pesel}}
                </div>
            </li>
            <li *ngIf="noPesel" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Rodzaj dokumentu</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-dropdown [options]="identityTypes" [(ngModel)]="shareholder.personalData!.identityType" placeholder="Wybierz rodzaj dokumentu" optionLabel="key" optionValue="value" name="idType" #pidType="ngModel" [required]="true" class="p-fluid"></p-dropdown>
                    <small *ngIf="pidType.invalid && (pidType.dirty || pidType.touched)" class="p-error">
                        <div *ngIf="pidType?.errors?.['required']">
                            Rodzaj dokumentu jest wymagany
                        </div>
                    </small>
                </div>
            </li>
            <li *ngIf="noPesel" class="flex align-items-center py-3 px-2 border-top-1  border-bottom-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Seria i numer</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <input type="text" [(ngModel)]="shareholder.personalData!.identityValue" class="p-inputtext-sm" pInputText  [pKeyFilter]="identityFilter" name="idNumber" #pidNumber="ngModel" required/>
                    <small *ngIf="pidNumber.invalid && (pidNumber.dirty || pidNumber.touched)" class="p-error">
                        <div *ngIf="pidNumber?.errors?.['required']">
                            Seria i numer dokumentu są wymagane
                        </div>
                    </small>
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Zaświadczenie z Krajowego Rejestru Karnego [ w formie pliku ZIP]*
                    <i class="pi pi-info-circle" pTooltip="Zaświadczenie z Krajowego Rejestru Karnego o niekaralności za przestępstwa, o których mowa w art. 59da ust. 2 pkt 1 ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim w formacie zip (plik zip zawiera: XADES, dokument XML oraz dokument PDF) składa pośrednik kredytowy będący osobą fizyczną." aria-hidden="true"></i>
                </div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-fileUpload #krkForm mode="advanced" accept=".zip" [customUpload]="true" [auto]="true"
                                  (uploadHandler)="uploadHandler($event, krkForm)"
                                  (onRemove)="fileRemove(krkForm)"
                                  chooseLabel="Dodaj plik"
                                  [maxFileSize]=10000000
                                  invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                                  invalidFileTypeMessageDetail="dopuszczalny typ: zip"
                                  invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                                  invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
                    </p-fileUpload>
                    <small *ngIf="krkError" class="p-error">
                        <div>
                            Plik KRK jest wymagany
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{krkFile?.attachment?.name}}
                </div>
            </li>
        </ul>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-save"  label="Zapisz" (click)="saveShareholder()"></p-button>
    </ng-template>
</p-dialog>

<p-confirmDialog header="Znaleziono podobny wpis" icon="pi pi-info-circle" acceptLabel="Tak" rejectLabel="Nie"></p-confirmDialog>